import React from 'react'

const trackableContext = React.createContext()
export default trackableContext
